(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var body = document.body;
  var updateQueued = false;
  var relocationRecords = [];

  if (!body) return;

  function visible(element) {
    if (!element || element.hidden) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function updateStickyTop() {
    if (!mobileQuery.matches) {
      document.documentElement.style.removeProperty('--bf-mobile-sticky-top');
      return;
    }

    var announcement = document.querySelector('.announcement-bar');
    var header = document.querySelector('.site-header--stuck') || document.querySelector('.site-header');
    var height = 0;

    if (announcement && visible(announcement)) height += announcement.getBoundingClientRect().height;
    if (header && visible(header)) height += header.getBoundingClientRect().height;

    document.documentElement.style.setProperty('--bf-mobile-sticky-top', Math.max(58, Math.round(height)) + 'px');
  }

  function updateSurfaceState() {
    if (!mobileQuery.matches) {
      body.classList.remove('bf-mobile-blocking-surface', 'bf-mobile-cart-open', 'bf-mobile-menu-open', 'bf-mobile-filter-open');
      return;
    }

    var cartOpen = visible(document.querySelector('#CartDrawer.drawer--is-open'));
    var menuOpen = visible(document.querySelector('#NavDrawer.drawer--is-open'));
    var filterOpen = visible(document.querySelector('#FilterDrawer.drawer--is-open'));
    var refreshOpen = visible(document.querySelector('.bf-site-refresh.is-visible:not([hidden])'));
    var themeModalOpen = Array.prototype.some.call(document.querySelectorAll('.modal.is-active, .modal--is-active, [role="dialog"][open]'), visible);

    body.classList.toggle('bf-mobile-cart-open', cartOpen);
    body.classList.toggle('bf-mobile-menu-open', menuOpen);
    body.classList.toggle('bf-mobile-filter-open', filterOpen);
    body.classList.toggle('bf-mobile-blocking-surface', cartOpen || menuOpen || filterOpen || refreshOpen || themeModalOpen);
  }

  function setupCollectionIntros() {
    if (!mobileQuery.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('.bf-collection-intro__copy'), function (copy, index) {
      if (copy.dataset.bfMobileIntroReady === 'true') return;
      var paragraph = copy.querySelector(':scope > p');
      if (!paragraph || paragraph.textContent.trim().length < 170) return;

      copy.dataset.bfMobileIntroReady = 'true';
      copy.classList.add('bf-mobile-intro-collapsed');
      if (!paragraph.id) paragraph.id = 'BfMobileCollectionIntro-' + index;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bf-mobile-intro-toggle';
      button.textContent = 'More details';
      button.setAttribute('aria-controls', paragraph.id);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function () {
        var collapsed = copy.classList.toggle('bf-mobile-intro-collapsed');
        button.textContent = collapsed ? 'More details' : 'Less details';
        button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
      paragraph.insertAdjacentElement('afterend', button);
    });
  }

  function setupCollectionDetails() {
    if (!mobileQuery.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('.collection-content .collection__description'), function (content, index) {
      if (content.dataset.bfMobileDetailsReady === 'true') return;
      if (String(content.textContent || '').replace(/\s+/g, ' ').trim().length < 260) return;

      content.dataset.bfMobileDetailsReady = 'true';
      content.classList.add('bf-mobile-detail-collapsed');
      if (!content.id) content.id = 'BfMobileCollectionDetails-' + index;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bf-mobile-detail-toggle';
      button.textContent = 'More collection details';
      button.setAttribute('aria-controls', content.id);
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function () {
        var collapsed = content.classList.toggle('bf-mobile-detail-collapsed');
        button.textContent = collapsed ? 'More collection details' : 'Less collection details';
        button.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
      content.insertAdjacentElement('afterend', button);
    });
  }

  function setupCollectionShoppingPriority() {
    if (!mobileQuery.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('.collection-content'), function (content) {
      var gridWrapper = content.querySelector('.collection-grid__wrapper');
      if (!gridWrapper) return;

      Array.prototype.forEach.call(content.querySelectorAll('.bf-collection-benefits'), function (benefits) {
        if (benefits.dataset.bfMobileRelocated === 'true') return;
        relocationRecords.push({
          element: benefits,
          parent: benefits.parentNode,
          nextSibling: benefits.nextSibling
        });
        benefits.dataset.bfMobileRelocated = 'true';
        benefits.classList.add('bf-mobile-relocated-content');
        gridWrapper.insertAdjacentElement('afterend', benefits);
      });

      var fallPalette = content.querySelector('.collection__description .bf-fall-palette');
      if (!fallPalette) return;
      var description = fallPalette.closest('.collection__description');
      if (!description || description.dataset.bfMobileRelocated === 'true') return;
      var toggle = description.nextElementSibling;
      var hasToggle = toggle && toggle.classList.contains('bf-mobile-detail-toggle');

      relocationRecords.push({
        element: description,
        parent: description.parentNode,
        nextSibling: hasToggle ? toggle.nextSibling : description.nextSibling,
        companion: hasToggle ? toggle : null
      });
      description.dataset.bfMobileRelocated = 'true';
      description.classList.add('bf-mobile-relocated-content');
      gridWrapper.insertAdjacentElement('afterend', description);
      if (hasToggle) {
        description.insertAdjacentElement('afterend', toggle);
      }
    });
  }

  function restoreDesktopStructure() {
    relocationRecords.forEach(function (record) {
      if (!record.element || !record.parent) return;
      var reference = record.nextSibling && record.nextSibling.parentNode === record.parent
        ? record.nextSibling
        : null;
      record.parent.insertBefore(record.element, reference);
      if (record.companion) record.parent.insertBefore(record.companion, reference);
      delete record.element.dataset.bfMobileRelocated;
      record.element.classList.remove('bf-mobile-relocated-content');
    });
    relocationRecords = [];

    Array.prototype.forEach.call(document.querySelectorAll('.bf-mobile-product-points'), function (group) {
      var blocks = group.parentNode;
      while (group.firstChild) blocks.insertBefore(group.firstChild, group);
      group.remove();
      if (blocks && blocks.dataset) delete blocks.dataset.bfMobilePointsReady;
    });
  }

  function setupCombinedListingTabs() {
    if (!mobileQuery.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('.mpg-swatch'), function (root) {
      var nav = root.querySelector('.mpg-swatch__nav');
      if (!nav) return;

      root.classList.add('bf-mobile-combined-tabs');
      nav.classList.add('bf-mobile-combined-tabs__rail');
      nav.setAttribute('role', 'list');

      var options = nav.querySelectorAll('.mpg-swatch__option');
      Array.prototype.forEach.call(options, function (option) {
        var label = option.getAttribute('o-value');
        var tooltip = option.querySelector('.mpg-tooltip');
        if (!label && tooltip) label = String(tooltip.textContent || '').trim();
        label = label || 'Product option';

        option.classList.add('bf-mobile-combined-tabs__option');
        option.setAttribute('role', 'link');
        option.setAttribute('aria-label', label);
        if (option.classList.contains('selected')) {
          option.setAttribute('aria-current', 'true');
        } else {
          option.removeAttribute('aria-current');
        }
        var isDisabled = option.classList.contains('disabled');
        if (isDisabled) {
          option.setAttribute('aria-disabled', 'true');
          option.setAttribute('tabindex', '-1');
        } else {
          option.removeAttribute('aria-disabled');
          option.setAttribute('tabindex', '0');
        }

        if (option.dataset.bfMobileKeyboardReady !== 'true') {
          option.dataset.bfMobileKeyboardReady = 'true';
          option.addEventListener('keydown', function (event) {
            if (option.classList.contains('disabled')) return;
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            option.click();
          });
        }
      });

      if (nav.dataset.bfMobileSelectedCentered === 'true') return;
      var selected = nav.querySelector('.mpg-swatch__option.selected');
      if (!selected) return;

      nav.dataset.bfMobileSelectedCentered = 'true';
      window.requestAnimationFrame(function () {
        var target = selected.offsetLeft - ((nav.clientWidth - selected.offsetWidth) / 2);
        nav.scrollLeft = Math.max(0, target);
      });
    });
  }

  function setupProductPoints() {
    if (!mobileQuery.matches) return;

    Array.prototype.forEach.call(document.querySelectorAll('[data-product-blocks]'), function (blocks) {
      if (blocks.dataset.bfMobilePointsReady === 'true') return;

        var points = Array.prototype.filter.call(blocks.children, function (child) {
          return child.classList
            && child.classList.contains('product-block--sales-point')
            && !child.classList.contains('bf-inventory-badge');
        });
      if (points.length < 2) return;

      blocks.dataset.bfMobilePointsReady = 'true';
      var group = document.createElement('div');
      group.className = 'bf-mobile-product-points';
      points[0].insertAdjacentElement('beforebegin', group);
      points.forEach(function (point) {
        group.appendChild(point);
      });
    });
  }

  function scheduleUpdate() {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(function () {
      updateQueued = false;
      if (mobileQuery.matches) {
        setupCollectionIntros();
        setupCollectionDetails();
        setupCollectionShoppingPriority();
        setupCombinedListingTabs();
        setupProductPoints();
      } else {
        restoreDesktopStructure();
      }
      updateStickyTop();
      updateSurfaceState();
    });
  }

  var observer = new MutationObserver(scheduleUpdate);
  var observedSurfaces = [
    document.documentElement,
    body,
    document.querySelector('#CartDrawer'),
    document.querySelector('#NavDrawer'),
    document.querySelector('#FilterDrawer'),
    document.querySelector('.bf-site-refresh')
  ].filter(Boolean);

  observedSurfaces.forEach(function (surface) {
    observer.observe(surface, {
      attributes: true,
      attributeFilter: ['class', 'hidden', 'style', 'aria-hidden']
    });
  });

  observer.observe(body, { childList: true, subtree: true });

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  window.addEventListener('pageshow', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('bloomingful:collection-filtered', scheduleUpdate);
  document.addEventListener('bloomingful:wsaio-pricing-updated', scheduleUpdate);

  if (typeof mobileQuery.addEventListener === 'function') mobileQuery.addEventListener('change', scheduleUpdate);
  scheduleUpdate();
  window.setTimeout(scheduleUpdate, 800);
  window.setTimeout(scheduleUpdate, 2600);
})();
